import { cn } from '@/lib/utils';

export interface LegalSection {
  title: string;
  content?: string[];
  subsections?: LegalSection[];
}

interface LegalSectionProps {
  section: LegalSection;
  level?: number;
}

export default function LegalSection({ section, level = 1 }: LegalSectionProps) {
  return (
    <div className="mb-6">
      {section.title && (
        <h2 className={cn(
          "font-semibold mb-3",
          level === 1 ? "text-xl" : "text-lg",
        )}>
          {section.title}
        </h2>
      )}
      
      {section.content && (
        <div className="space-y-2">
          {section.content.map((paragraph, pIndex) => {
            // Check if this is a single-line item that doesn't end with punctuation
            const isSingleItem = paragraph.length < 150 && 
              !paragraph.includes(". ") && 
              !paragraph.endsWith(".") && 
              !paragraph.endsWith(":") && 
              !paragraph.endsWith("?") && 
              !paragraph.endsWith("!");
            
            return isSingleItem ? (
              <div key={pIndex} className="flex gap-2 pl-4">
                <span className="text-primary">•</span>
                <span className="text-muted-foreground">{paragraph}</span>
              </div>
            ) : (
              <p key={pIndex} className="text-muted-foreground">
                {paragraph}
              </p>
            );
          })}
        </div>
      )}

      {section.subsections && (
        <div className="mt-4 pl-4 border-l-2 border-muted">
          {section.subsections.map((subsection, index) => (
            <LegalSection 
              key={index} 
              section={subsection} 
              level={level + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
}